<bn-loading-overlay></bn-loading-overlay>
<div class="container">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <h5>Pessoas Jurídicas</h5>
    <div class="row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar(false)"
          (click)="buscar(false)" [disabled]="!pesquisaForm.valid">Pesquisar
        </button>
      </div>
    </div>
    <div class="row mt-4">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="nome">Nome da Pessoa Jurídica: </label>
        <select id="nome" class="form-select" ngDefaultControl formControlName="nome">
          <option [ngValue]=null>Todos</option>
          <option *ngFor="let item of nomes">{{ item }}</option>
        </select>
      </div>
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="sigla">Sigla da Pessoa Jurídica: </label>
        <select id="sigla" class="form-select" ngDefaultControl formControlName="sigla">
          <option [ngValue]=null>Todos</option>
          <option *ngFor="let item of siglas">{{ item }}</option>
        </select>
      </div>
      <div class="bn-form-group col-md-2">
        <label class="form-label" for="cnpj">CNPJ da Pessoa Jurídica: </label>
        <input id="cnpj" type="text" class="form-control" bnMask="CNPJ" formControlName="cnpj">
      </div>
    </div>
  </form>
</div>

<app-pessoas-juridicas-listagem
  [pessoasJuridicas]="pessoasJuridicas"
  [msgSemResultado]="msgSemResultado"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  [dataHoraResultado]="dataHoraResultado"
  (aoMudarPagina)="mudancaPagina($event)"
  (exportarPessoasJuridicas)="exportarPessoasJuridicas()">

</app-pessoas-juridicas-listagem>
